module.exports = __webpack_public_path__ + "img/avatar.0fd8191b.png";